import { AUTH_MODE } from './config.ts';

let readAccessToken: () => string | null = () => null;
let cachedAccessToken: string | null = null;

export function bindAccessTokenReader(reader: () => string | null): void {
  readAccessToken = reader;
}

export function getAccessToken(): string | null {
  if (AUTH_MODE === 'dev') return 'dev-access-token';
  return AUTH_MODE === 'local' || AUTH_MODE === 'mock-sso' || AUTH_MODE === 'mock-entra' || AUTH_MODE === 'mock-msal'
    ? readAccessToken() : cachedAccessToken;
}

export function setAccessToken(token: string | null): void {
  cachedAccessToken = token;
}